// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-small-text-87cb1ea7"};